import { EmptyState } from '@/components/EmptyState'

export const EmptyResult = () => (
  <EmptyState
    mt={'130px'}
    title={'フィードが見つかりませんでした'}
    description={
      <>
        検索にヒットしませんでした。
        <br />
        キーワードを変えて企業フィードを探してみましょう。
      </>
    }
  />
)
